import { QRCodeCanvas } from "qrcode.react";
import { toast } from "sonner";
import { Download, Copy, Nfc } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { publicUrl } from "@/lib/card";

const NFC_STEPS = [
  "Installa l'app gratuita \"NFC Tools\" su iPhone o Android.",
  "Apri Scrivi › Aggiungi record › URL / URI.",
  "Incolla il link della tua scheda e conferma.",
  "Avvicina la carta taptolink al telefono per scriverla.",
];

export const QrTab = ({ card, set, savedSlug }) => {
  const url = publicUrl(savedSlug);
  const copy = () => navigator.clipboard.writeText(url).then(() => toast.success("Link copiato"));
  const download = () => {
    const a = document.createElement("a");
    a.href = document.getElementById("qr-canvas").toDataURL("image/png");
    a.download = `qr-${savedSlug}.png`;
    a.click();
  };

  return (
    <div className="space-y-6">
      <div className="rounded-2xl border border-slate-200 bg-white p-6 md:p-8">
        <h3 className="text-lg font-semibold">Indirizzo della scheda</h3>
        <div className="mt-6 space-y-2">
          <Label className="text-xs font-semibold uppercase tracking-wider text-slate-500">Nome personalizzato</Label>
          <div className="flex items-center overflow-hidden rounded-md border border-input bg-white">
            <span className="hidden border-r border-input bg-slate-50 px-3 py-2 font-mono-ui text-xs text-slate-500 sm:block">{window.location.host}/c/</span>
            <Input value={card.slug} onChange={(e) => set("slug")(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ""))} data-testid="input-slug" className="border-0 font-mono-ui focus-visible:ring-0" />
          </div>
          <p className="text-xs text-slate-500">Salva per applicare la modifica. Minuscole, numeri e trattini.</p>
        </div>
      </div>
      <div className="grid gap-6 rounded-2xl border border-slate-200 bg-white p-6 md:grid-cols-[auto_1fr] md:p-8">
        <div className="rounded-xl border border-slate-200 p-4"><QRCodeCanvas id="qr-canvas" value={url} size={180} marginSize={1} data-testid="qr-code" /></div>
        <div className="min-w-0">
          <h3 className="text-lg font-semibold">Codice QR</h3>
          <p data-testid="public-url-text" className="mt-2 break-all font-mono-ui text-sm text-blue-600">{url}</p>
          <div className="mt-6 flex flex-wrap gap-2">
            <Button onClick={download} className="bg-slate-900" data-testid="button-download-qr"><Download size={16} className="mr-2" /> Scarica PNG</Button>
            <Button onClick={copy} variant="outline" data-testid="button-copy-link"><Copy size={16} className="mr-2" /> Copia link</Button>
          </div>
        </div>
      </div>
      <div className="rounded-2xl bg-slate-900 p-6 text-white md:p-8">
        <div className="flex items-center gap-3"><Nfc className="text-blue-400" /><h3 className="text-lg font-semibold">Scrivi il chip NFC</h3></div>
        <ol className="mt-6 space-y-3">
          {NFC_STEPS.map((s, i) => (
            <li key={s} className="flex gap-4 text-sm text-slate-300"><span className="font-mono-ui text-blue-400">0{i + 1}</span>{s}</li>
          ))}
        </ol>
      </div>
    </div>
  );
};
